import React from 'react';
import { Button, VStack } from '@chakra-ui/react';

// Google OAuth and API Configuration - read from .env files
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
const SCOPES = process.env.REACT_APP_OAUTH_SCOPES;

// Validate required environment variables
if (!CLIENT_ID || !REDIRECT_URI || !SCOPES) {
  console.error('Missing required OAuth environment variables:', {
    CLIENT_ID: !!CLIENT_ID,
    REDIRECT_URI: !!REDIRECT_URI,
    SCOPES: !!SCOPES
  });
}

function AuthButtons({ isAuthenticated, onAuthSuccess, onSignOut }) {

  // Handle authentication button click — redirect flow (mobile-friendly)
  const handleAuthClick = () => {
    // Build Google OAuth URL for authorization code flow
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${CLIENT_ID}&` +
      `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
      `response_type=code&` +
      `scope=${encodeURIComponent(SCOPES)}&` +
      `access_type=offline&` +
      `prompt=consent`;
    
    // Redirect user to Google's OAuth consent screen
    // After user authorizes, Google redirects back to REDIRECT_URI with authorization code
    // oauth-callback.html exchanges the code for a token and stores it in localStorage
    window.location.href = authUrl;
  };

  // Handle sign out button click
  const handleSignOutClick = () => {
    // Log out from frontend (local storage)
    onSignOut();
    
    // Get the base API URL from environment variables
    const baseApiUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:8000';
    
    // Use relative path if same origin, otherwise use full URL
    const logoutUrl = window.location.origin.includes(baseApiUrl) ? 
      '/logout.php' :  // Same origin
      `${baseApiUrl}/logout.php`;  // Cross-origin
    
    console.log(`Logging out using backend URL: ${logoutUrl}`);
    
    // Also log out from backend session
    fetch(logoutUrl, {
      method: 'POST',
      credentials: 'include', // Important for cookies/sessions
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      console.log('Backend logout result:', data);
    })
    .catch(error => {
      console.error('Error logging out from backend:', error);
    });
  };

  return (
    <VStack spacing={4} width="100%">
      {!isAuthenticated ? (
        <Button
          width="100%"
          bg="blue.700"
          color="white"
          size="lg"
          fontSize="md"
          onClick={handleAuthClick}
          boxShadow="lg"
          _hover={{
            boxShadow: 'xl',
            transform: 'translateY(-2px)',
            bg: "blue.800",
          }}
          transition="all 0.2s"
        >
          Sign in with Google
        </Button>
      ) : (
        <Button
          width="100%"
          colorScheme="red"
          variant="outline"
          size="lg"
          fontSize="md"
          onClick={handleSignOutClick}
        >
          Sign Out
        </Button>
      )}
    </VStack>
  );
}

export default AuthButtons;